import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2"
    }, [
      _createElementVNode("path", { d: "M3 3v12.572h12.572V6.229L12.342 3z" }),
      _createElementVNode("path", { d: "M9.286 12.171a2.408 2.408 0 1 0 0-4.816 2.408 2.408 0 0 0 0 4.816M8.645 3H3.063v2.532h5.582z" })
    ], -1)
  ]))]))
}
export default { render: render }